import { Button } from '@strata/react-buttons';
import { WarningDialog } from '@strata/react-dialog';
import { DetailLabelValuePair } from '@strata/react-label-value-pairs';
import PropTypes from 'prop-types';

const Title = 'Confirm Send File';

const confirmMessage =
    'Are you sure you want to send this outbound file? By sending this file you are confirming that you have reviewed its contents and that it contains no errors.';

export const SendOutboundFileDialog = ({
    isOpen,
    isSending = false,
    pharmacy = undefined,
    pharmacistInCharge = undefined,
    pharmacyAddress = undefined,
    pharmacyEmail = undefined,
    healthPlans = undefined,
    prescriptions = undefined,
    onClose,
    onConfirm,
}) => (
    <WarningDialog
        isOpen={isOpen}
        dialogTitle={Title}
        primaryButtonDisabled={isSending}
        onPrimaryButtonClick={onConfirm}
        onSecondaryButtonClick={onClose}
        primaryButtonIntent={Button.Intent.PRIMARY}
        primaryButtonLabel="Yes, Send File"
        secondaryButtonLabel="Cancel"
        dialogContent={
            <>
                <div className="padding__bottom--medium">{confirmMessage}</div>
                <div className="flex__gap--large">
                    <div
                        className="flex__gap--medium"
                        style={{ flexDirection: 'column', width: '50%' }}
                    >
                        <DetailLabelValuePair label="Receiving Pharmacy" value={pharmacy} />
                        <DetailLabelValuePair
                            label="Receiving Pharmacy Address"
                            value={pharmacyAddress}
                        />
                        <DetailLabelValuePair label="Prescriptions" value={prescriptions} />
                    </div>
                    <div
                        className="flex__gap--medium"
                        style={{ flexDirection: 'column', width: '50%' }}
                    >
                        <DetailLabelValuePair
                            label="Pharmacist in Charge"
                            value={pharmacistInCharge}
                        />
                        <DetailLabelValuePair label="Email Address" value={pharmacyEmail} />
                        <DetailLabelValuePair label="Health Plans" value={healthPlans} />
                    </div>
                </div>
            </>
        }
    />
);

SendOutboundFileDialog.Title = Title;

SendOutboundFileDialog.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    isSending: PropTypes.bool,
    pharmacy: PropTypes.string,
    pharmacistInCharge: PropTypes.string,
    pharmacyAddress: PropTypes.string,
    pharmacyEmail: PropTypes.string,
    healthPlans: PropTypes.string,
    prescriptions: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    onClose: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
};
